export const API_PATH = '/zaimy/api';
